import { useTranslation } from 'react-i18next';

const stats = [
  { value: '14+', labelKey: 'stats.categories' },
  { value: '1000+', labelKey: 'stats.products' },
  { value: '2026', labelKey: 'stats.updated' },
  { value: '5000+', labelKey: 'stats.users' },
];

export default function StatsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-accent-50/50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-18">
        <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-10">
          {t('stats.label')}
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat) => (
            <div key={stat.labelKey} className="text-left">
              <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">
                {stat.value}
              </p>
              <p className="mt-2 text-sm text-foreground-500 font-medium">
                {t(stat.labelKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}